import { Row, Input, Button, Form, Modal } from 'antd';
import Icon from "@mdi/react";
import { mdiArrowLeft } from '@mdi/js';
import { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import environment from "../../../../../config/environment";
import { i18n } from '../../../../../i18n/i18n';
import { useTranslation } from "react-i18next";
import { namespaces } from "../../../../../i18n/i18n.constants";
import queryString from "query-string";

const LoginMemberPage = () => {
  const [dataCardId, setDataCardId] = useState<string>('');
  const [dataCardMobile, setDataMobile] = useState<string>('');
  const history = useHistory();
  const { t } = useTranslation(namespaces.pages.daolinv);

  const { search } = useLocation();
  const query: any = queryString.parse(search);
  if (
    query?.from !== undefined || query?.reques !== undefined || query?.customerid !== undefined
  ) {
    localStorage.setItem("param_from", query?.from);
    localStorage.setItem("param_reques", query?.reques);
    localStorage.setItem("param_customer", query?.customerid);
  }
  const paramFrom = localStorage.getItem("param_from");
  const paramReques = localStorage.getItem("param_reques");
  const param_customer = localStorage.getItem("param_customer");

  const onChangeCardId = (e) => {
    setDataCardId(e.target.value);
    console.log(`setDataCardId = ${dataCardId}`);
  };

  const onChangeMobile = (e) => {
    setDataMobile(e.target.value);
    console.log(`dataCardMobile  = ${dataCardMobile}`);
  };

  const onSubmitLogin = (e: React.FormEvent<HTMLFormElement>) => {
    const url = `${environment?.baseApi}/verify`

    var mockData = {
      cardId: dataCardId,
      mobile: dataCardMobile
    }
    console.log(`BaseAPI  = ${url}`);
    console.log(`mockData  = ${mockData.cardId}`);
    axios.post(url, mockData)
      .then(res => {
        if (res.status === 200) {
          console.log('res', res.data)
          console.log('res.data.success', res.data.success);
          if (res.data.success === "0") {
            Modal.error({
              title: t("popup_login_error_title"),
              content: t("popup_login_error_content"),
              icon: '',
              onOk() { },
            });
          }
          if (res.data.success === "1") {
            history.push({
              pathname: "/contents/daolInv/consentRMF/otp",
              state: {
                phone: dataCardMobile,
                customerId: res.data.customerId
              },
            });
          }
          // setMessageAlert(res.data.message)
          // setShowLoading(true)
          // setTimeout(() => {
          //   setShowLoading(false)
          //   history.push("/");
          // }, 1000);
        }
      }).catch((error) => {
        console.error(error);
      });
  };


  return (
    <>
      <div className="home-page">
        <div className="container">
          {console.log('i18n.language', i18n.language)}
          <Row className="container-main row">
            <div className="content-left col-sm-5">
            <a onClick={() => history.push(`/home?from=${paramFrom}&reques=${paramReques}&customerid=${param_customer}`)}>
              <Icon path={mdiArrowLeft} size="30" color="#FFFFFF" /></a>
              <div className="info-left">
                <p className="text-center text-header">{t("login_title")}</p>
                <p className="content-sub">
                  {t("login_text_descrip")}
                  {t("login_text_descrip_p2")}
                </p>
              </div>
            </div>

            <div className="content-right col-sm-7">
              <p className="text-center text-header">{t("login_descrip_header")}</p>

              <Form name="normal_login" className="login-form" initialValues={{ remember: true }} onFinish={onSubmitLogin}>
                <Form.Item
                  name="cardId"
                  className="from-input"
                  rules={[{ required: true, message: t("login_error_cardId") }]}
                >
                  <Input placeholder={t("login_cardId_placeholder")} onChange={onChangeCardId} className="input-info" />
                </Form.Item>
                <Form.Item
                  name="phoneNumber"
                  className="from-input"
                  rules={[{ required: true, message: t("login_error_mobile") }]}
                >
                  <Input
                    placeholder={t("login_mobile_placeholder")}
                    onChange={onChangeMobile}
                    className="input-info"
                    type="number"
                  />
                </Form.Item>

                <Form.Item className="container-button">
                  <Button type="primary" htmlType="submit" className="login-form-button">
                    {t("btn_login")}
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </Row>
        </div>
      </div>
    </>
  );
};
export default LoginMemberPage;
function useEffect(arg0: () => void) {
  throw new Error('Function not implemented.');
}

